import { Component, OnInit } from '@angular/core';
import { IndexFormationService } from 'src/services/index-formation.service';
import { IndexFormationListe } from 'src/models/indexFormationListe';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-index-formation',
    imports: [MatTableModule, MatProgressSpinnerModule, RouterModule, TranslateModule, FormsModule, MatIconModule, MatButtonModule],
    templateUrl: './index-formation.component.html',
    styleUrl: './index-formation.component.scss'
})
export class IndexFormationComponent implements OnInit {
  formations: IndexFormationListe[] = [];
  filteredFormations: IndexFormationListe[] = [];
  isLoading = false;
  displayedColumns: string[] = ['nomFormation', 'nomFR', 'nomEN', 'nomES', 'type', 'dureeMinutes'];
  searchTerm: string = '';

  constructor(private indexFormationService: IndexFormationService) { }

  ngOnInit(): void {
    this.isLoading = true;
    this.indexFormationService.getFormations().subscribe({
      next: (data) => {
        this.formations = data;
        this.filteredFormations = data;
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  applyFilter(): void {
    if (!this.searchTerm.trim()) {
      this.filteredFormations = this.formations;
    } else {
      const searchTermLower = this.searchTerm.toLowerCase();
      this.filteredFormations = this.formations.filter(formation => 
        formation.nomFormation?.toLowerCase().includes(searchTermLower) ||
        formation.nomFR?.toLowerCase().includes(searchTermLower) ||
        formation.nomEN?.toLowerCase().includes(searchTermLower) ||
        formation.nomES?.toLowerCase().includes(searchTermLower) ||
        formation.type?.toLowerCase().includes(searchTermLower) ||
        formation.dureeMinutes?.toString().includes(searchTermLower)
      );
    }
  }

  resetFilter(): void {
    this.searchTerm = '';
    this.filteredFormations = this.formations;
  }
}
